import { render } from "./Maibi.vue?vue&type=template&id=39cf2fcb&scoped=true"
import script from "./Maibi.vue?vue&type=script&lang=js"
export * from "./Maibi.vue?vue&type=script&lang=js"

import "./Maibi.vue?vue&type=style&index=0&id=39cf2fcb&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cf2fcb"]])

export default __exports__